import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, InputAdornment } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Table from "../../components/Common/Table";
import CheckBox from "../../components/Form/CheckBox";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomAutocomplete from "../../components/Form/CustomAutocomplete";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import RadioButtonGroupInGrid from "../../components/Form/RadioButtonGroupInGrid";
import { createPromocode, getCategoryListing, getPromocodeDetails, resetPromocodeState, updatePromocode } from "../../store/actions";
import FormEditors from "../Forms/FormEditors";
import "../Orders/order.css";
import "../Vouchers/voucher.css";
import moment from "moment";


const AddPromoCode = ({ title, type, promocodeDetails, categoryListing, editPromocode, addPromocodeArr, errorPromocode, userPermission, productListing }) => {
    const { ID } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef();
    const [filteredCatList, setFilteredCatList] = useState(categoryListing)
    const [filteredProList, setFilteredProList] = useState(productListing)

    useEffect(() => {
        if (userPermission?.length > 0) {
            !userPermission?.includes("view-marketing") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        dispatch(resetPromocodeState())
        const payload = {
            paginate: 0,
            sort_order: "asc",
            size: "",
            search: ""
        }
        dispatch(getCategoryListing(payload))

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const defaultValues = {
        name: '',
        code: '',
        is_percentage: '',
        discount_value: '',
        start: '',
        end: '',
        discount_type: "product",
        product_applicability_type: '',
        limit: '',
        status: '1',
        sort_order: '',
        has_quantity: 1,
        has_limit_per_customer: 1,
        has_min_spend: 0,
        has_min_items: 0,
        no_min_spend: 1,
    }
    const [values, setFormValues] = useState(defaultValues);

    useEffect(() => {
        if (values?.products?.length > 0) {
            setFilteredProList("")
            handleCheckDuplicate("Add", setFilteredProList, productListing, values?.products)
        }
        else {
            setFilteredProList(productListing)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productListing, values?.products, values.product_applicability_type]);

    useEffect(() => {
        if (values?.categories?.length > 0) {
            setFilteredCatList("")
            handleCheckDuplicate("Add", setFilteredCatList, categoryListing, values?.categories)
        }
        else {
            setFilteredCatList(categoryListing)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryListing, values?.categories, values.product_applicability_type]);

    const handleCheckDuplicate = (type, setData, oriArray, data, addedData) => {
        let tempAccessoriesData = data
        if (type === "Add") {
            if (tempAccessoriesData?.length > 0) {
                const usedIds = tempAccessoriesData?.length > 0 && tempAccessoriesData?.map(item => item);
                const newFilteredCat = oriArray?.length > 0 && oriArray.filter(cat => !usedIds?.includes(cat.id));
                setData(newFilteredCat || [])
            }
        } else if (type === "Delete") {
            const usedIds = addedData?.length > 0 && addedData?.map(item => item);
            const newFilteredCat = usedIds?.length > 0 ? oriArray?.length > 0 && oriArray.filter(cat => !usedIds?.includes(cat.id)) : oriArray;
            setData(newFilteredCat || [])
        }
    }

    const [loading, setIsLoading] = useState(false);
    const [isNoEndDate, setIsNoEndDate] = useState(false);
    const [isPromocodeHasQuantity, setIsPromocodeHasQuantity] = useState("1");
    const [hasUsageLimit, setHasUsageLimit] = useState("1");
    const [itemAmount, setItemAmount] = useState('');
    const [totalOrder, setTotalOrder] = useState('');
    const [selectedProductCategory, setSelectedProductCategory] = useState('');
    const [selectedProductCategoryList, setSelectedProductCategoryList] = useState('');
    const [minOrderValue, setMinOrderValue] = useState("no_min_spend");
    const [width, setWidth] = useState(window.innerWidth);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const statusList = [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
    ]

    const discountTypeList = [
        { label: "Percentage (%)", value: "1" },
        { label: "Fixed Amount Discount (S$)", value: "0" },
    ]

    const discountApplyList = [
        { label: "Product", description: 'discount by products or categories', value: "product" },
        { label: "Shipping", description: 'discount applies only to shipping fees', value: "shipping" },
    ]

    const promocodeApplyList = [
        { label: "Product", value: "products" },
        { label: "Categories", value: "categories" },
    ]

    const minOrderList = [
        { label: "No minimum spend", value: "no_min_spend" },
        { label: "Number of items", value: "has_min_items" },
        { label: "Order total", value: "has_min_spend" },
    ]

    const yesNoList = [
        { label: "Yes", value: "1" },
        { label: "No", value: "0" },
    ]

    const handleDiscountValueChg = (e, idx) => {
        const newValue = e;

        setFormValues(prevValues => {
            const updatedValues = { ...prevValues, discount_value: newValue };

            if (updatedValues.is_percentage == 1 && newValue > 100) {
                setNotification({ open: true, msg: 'Discount percentage cannot exceed 100%', type: 'warning' });
                return { ...prevValues }
            }

            return updatedValues;
        });
    };

    const header = [
        {
            Header: "Product",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {
                            values?.product_applicability_type === "products" &&
                            <div>
                                <div style={{ fontSize: 16 }}>{cellProps.name}</div>
                                <div className="subheader-2">Category:
                                    {
                                        cellProps?.categories?.map((x, idx) =>
                                            <span key={idx} style={{ color: '#282828' }}> {x}{idx !== cellProps?.categories?.length - 1 && ", "}</span>
                                        )
                                    }
                                </div>
                                <div className="subheader-2">Price:
                                    <span style={{ textDecorationLine: 'line-through', textDecorationColor: '#282828' }}>S${cellProps.original_price}</span>
                                    <span style={{ color: '#101010', marginLeft: 5 }}><span style={{ color: '#101010', marginLeft: 5 }}>{values?.is_percentage == 1 ?
                                        `S$` + (cellProps?.original_price - (cellProps?.original_price * values?.discount_value / 100))
                                        :
                                        `S$` + (cellProps?.original_price - (values?.discount_value))
                                    }</span></span>
                                </div>
                            </div>
                        }
                        {
                            values?.product_applicability_type === "categories" &&
                            <div>
                                <div style={{ color: "#282828" }}>{cellProps?.name}</div>
                                <div className="subheader-3">Applicable products: {cellProps.product_count} products</div>
                            </div>
                        }
                    </React.Fragment>
                )
            },
            minWidth: 350,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <CustomIconButton
                            iconName={'ri-delete-bin-line'}
                            backgroundColor={'#44d62c'}
                            color={'white'}
                            borderStyle={'1px solid #44d62c'}
                            onClick={() => handleDeleteProductCategory(cellProps.id)}
                        />
                    </React.Fragment>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const handleSubmit = (type) => {
        if (type === "Add") {
            dispatch(createPromocode(values))
        }
        else if (type === "Edit") {
            // const filteredValues = Object.fromEntries(
            //     Object.entries(values).filter(([key, value]) => value !== "")
            // );
            dispatch(updatePromocode({ id: ID, promocode: values }))
        }

    }

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                dispatch(getPromocodeDetails({ id: ID }))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                const filtered = promocodeDetails || []

                if (filtered) {
                    setFormValues({
                        name: filtered?.name,
                        t_and_c: filtered?.t_and_c,
                        code: filtered?.code,
                        is_percentage: String(filtered?.is_percentage),
                        discount_type: filtered?.discount_type,
                        discount_value: filtered?.discount_value,
                        start: filtered?.start,
                        end: filtered?.end,
                        has_end_date: filtered?.has_end_date,
                        product_applicability_type: filtered?.product_applicability_type,
                        apply_to_all_product: String(filtered?.apply_to_all_product),
                        has_min_spend: filtered?.has_min_spend,
                        min_spend: filtered?.min_spend,
                        has_min_items: filtered?.has_min_items,
                        min_items: filtered?.min_items,
                        has_quantity: filtered?.has_quantity,
                        quantity: filtered?.quantity,
                        has_limit_per_customer: filtered?.has_limit_per_customer,
                        limit: filtered?.limit,
                        sort_order: filtered?.sort_order,
                        status: filtered.status,
                        categories: filtered?.categories?.length > 0 ? filtered?.categories.map((x, idx) =>
                            x.id
                        ) : "",
                        products: filtered?.products?.length > 0 ? filtered?.products.map((x, idx) =>
                            x.id
                        ) : "",
                        apply_to_all_category: String(filtered?.apply_to_all_category),
                    })
                    //need api to get the base64
                    setItemAmount(filtered?.min_items)
                    setTotalOrder(filtered?.min_spend)
                    setIsNoEndDate(filtered?.has_end_date === 1 ? false : true)
                    setIsPromocodeHasQuantity(filtered?.has_quantity?.toString())
                    setHasUsageLimit(filtered?.has_limit_per_customer?.toString())
                    if (filtered?.has_min_spend === 1) {
                        setMinOrderValue("has_min_spend")
                    } else if (filtered?.has_min_spend === 0 && filtered?.has_min_items === 0)
                        setMinOrderValue("no_min_spend")
                    else if (filtered?.has_min_items === 1)
                        setMinOrderValue("has_min_items")

                    if (filtered?.apply_to_all_category == 0 && filtered?.categories?.length > 0) {
                        var temp = []
                        filtered?.categories?.map((x, idx) =>
                            temp.push({
                                id: x?.id,
                                name: x?.category_name,
                                product_count: x?.total_products,
                            })
                        )
                        setSelectedProductCategoryList(temp)

                    } else if (filtered?.apply_to_all_category == 1) {
                        setSelectedProductCategoryList([])
                    }
                    else if (filtered?.apply_to_all_product == 0 && filtered?.products?.length > 0) {
                        var tempProduct = []
                        filtered?.products?.map((x, idx) =>
                            tempProduct.push({
                                id: x?.id,
                                name: x?.product_name,
                                categories: x?.categories?.map((y, idx) => y?.category_name),
                                original_price: x?.aspeed_price,
                            })
                        )

                        setSelectedProductCategoryList(tempProduct)
                    } else if (filtered?.apply_to_all_product == 1) {
                        setSelectedProductCategoryList([])
                    }
                }
            }
        }
    }, [promocodeDetails]);

    useEffect(() => {
        if (hasUsageLimit == 0) {
            handleValueChange('limit', "")
            handleValueChange('has_limit_per_customer', 0)
        } else {
            handleValueChange('has_limit_per_customer', 1)
        }
        if (isPromocodeHasQuantity == 0) {
            handleValueChange('quantity', "")
            handleValueChange('has_quantity', 0)
        } else {
            handleValueChange('has_quantity', 1)
        }
    }, [hasUsageLimit, isPromocodeHasQuantity]);

    useEffect(() => {
        if (type === "Edit") {
            if (editPromocode?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Updated Successfully",
                    type: "success",
                })
                dispatch(resetPromocodeState())
                dispatch(getPromocodeDetails({ id: ID }))
            }
        }
    }, [editPromocode]);

    useEffect(() => {
        if (type === "Add") {
            if (addPromocodeArr?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Added Successfully",
                    type: "success",
                })
                dispatch(resetPromocodeState())
                navigate("/promo-code")
            }
        }
    }, [addPromocodeArr]);

    const handleDeleteProductCategory = (id) => {
        const updatedList = selectedProductCategoryList.filter(item => item.id !== id);
        setSelectedProductCategoryList(updatedList);
        let temp = []
        updatedList.length > 0 && updatedList.map((x, idx) =>
            temp.push(x.id)
        )
        if (values?.product_applicability_type === "products") {
            handleValueChange("products", temp)
            handleValueChange("categories", [])
            handleCheckDuplicate("Delete", setFilteredProList, productListing, values?.products, temp)

        } else if (values?.product_applicability_type === "categories") {
            handleValueChange("categories", temp)
            handleValueChange("products", [])
            handleCheckDuplicate("Delete", setFilteredCatList, categoryListing, values?.categories, temp)

        }
    }

    const handleAddSelectedProductCategory = (type) => {
        if (selectedProductCategory) {
            let currentSelectedItem = type === "categories" ? filteredCatList.filter(item => item.id === selectedProductCategory) : filteredProList.filter(item => item.id === selectedProductCategory);
            let currentSelectedList = selectedProductCategoryList || [];
            currentSelectedList = [...currentSelectedList, currentSelectedItem[0]];
            setSelectedProductCategoryList(currentSelectedList);
            setSelectedProductCategory('');
            const temp = []
            currentSelectedList.length > 0 && currentSelectedList.map((x, idx) =>
                temp.push(x.id)
            )
            if (values?.product_applicability_type === "products") {
                handleValueChange("products", temp)
                handleValueChange("categories", [])
            } else if (values?.product_applicability_type === "categories") {
                handleValueChange("categories", temp)
                handleValueChange("products", [])
            }
        } else {
            setNotification({
                open: true,
                msg: "Please select product or category",
                type: 'error'
            })
        }

    }

    const handleValueChange = (key, value) => {
        if (value === "0") {
            setFormValues((prevValues) => ({
                ...prevValues,
                [key]: "0"
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [key]: value
            }));
        }
    };

    const error = errorPromocode?.[0]

    const renderBasicInfoForm = () => {
        return (
            <Card className="p-3 px-2">
                <CardBody>
                    <div className="setting-header">BASIC INFO</div>
                    <Divider className="my-2 mb-4" />
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <CustomTextField
                                title={'Name'}
                                values={values?.name}
                                onChange={(e) => handleValueChange('name', e)}
                                placeholder="e.g. First time customer"
                            // subtitle={'Buyers won’t see this—it\'s just for you to track the sale\'s performance.'}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.name}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTextField
                                title={'Promo code'}
                                subtitle={'This is what customer will enter at checkout to get a discount.'}
                                values={values?.code}
                                onChange={(e) => handleValueChange('code', e)}
                                type={'text'}
                                placeholder="e.g. FIRSTNAME"
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.code}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormEditors
                                title={'Terms and Conditions (if applicable)'}
                                value={values?.t_and_c || ""}
                                placeholder={'List any additional restrictions or terms you want your customers to know about. This info will show on eligible listings during your sale.'}
                                setValue={(e) => handleValueChange('t_and_c', e)}
                            />
                        </Grid>
                    </Grid>
                </CardBody>
            </Card>
        )
    }

    const renderPromocodeDetailsForm = () => {
        return (
            <Card className="p-3 px-2 mt-3">
                <CardBody>
                    <div className="setting-header">PROMOTION DETAILS</div>
                    <Divider className="my-2 mb-4" />
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <CustomSelect
                                title={'Discount type'}
                                values={values?.is_percentage || '-1'}
                                data={discountTypeList}
                                onChange={(e) => {
                                    handleValueChange('is_percentage', e);
                                    handleValueChange('discount_value', "")
                                }}
                                width={width > 378 ? "" : "70vw"}
                                placeholder={'Please select'}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.is_percentage}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                title={'Discount value'}
                                values={values?.discount_value}
                                onChange={(e, idx) =>
                                    handleDiscountValueChg(e, idx)
                                } InputProps={{
                                    startAdornment: values?.is_percentage === "0" && <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                                    endAdornment: values?.is_percentage === "1" && <InputAdornment position="end"><span style={{ color: '#999999' }}>%</span></InputAdornment>,
                                }}
                                type={'number'}
                                placeholder="0"
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.discount_value}</FormHelperText>}
                        </Grid>
                    </Grid>
                </CardBody>
            </Card>
        )
    }

    const renderValidityForm = () => {
        return (
            <Card className="p-3 px-2 mt-3">
                <CardBody>
                    <div className="setting-header">VALIDITY</div>
                    <Divider className="my-2 mb-4" />
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <CustomizedDatePicker
                                title={'Start on'}
                                values={values?.start && new Date(values?.start)}
                                setFormValues={(e) => handleValueChange('start', moment(e).format("YYYY-MM-DD 00:00:00"))}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.start}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomizedDatePicker
                                title={'Expires on'}
                                values={values?.end && new Date(values?.end)}
                                disabled={isNoEndDate}
                                setFormValues={(e) => { handleValueChange('end', moment(e).format("YYYY-MM-DD 23:59:59")); handleValueChange('has_end_date', 1) }}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.end}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={4} className="d-flex align-items-center pt-4 flex-wrap">
                            <CheckBox
                                label={'No end date'}
                                values={isNoEndDate}
                                onChange={(e) => { setIsNoEndDate(e.target.checked); handleValueChange('end', ""); handleValueChange('has_end_date', 0) }}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.has_end_date}</FormHelperText>}
                        </Grid>
                    </Grid>
                </CardBody>
            </Card>
        )
    }

    const renderApplicabilityForm = () => {
        return (
            <Card className="p-3 px-2 mt-3">
                <CardBody>
                    <div className="setting-header">APPLICABILITY</div>
                    <Divider className="my-2 mb-4" />
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} pb={1}>
                            <RadioButtonGroupInGrid
                                title={'Discount applies to'}
                                name={'discount_type'}
                                value={values.discount_type}
                                setValue={(e) => {
                                    handleValueChange('discount_type', e);
                                    handleValueChange('product_applicability_type', "");
                                    if (e === "shipping") {
                                        handleValueChange('apply_to_all_product', 0);
                                        handleValueChange('apply_to_all_category', 0);
                                    } else {
                                        handleValueChange('apply_to_all_product', "");
                                        handleValueChange('apply_to_all_category', "");
                                    }
                                    handleValueChange('has_min_spend', 0);
                                    handleValueChange('min_spend', "");
                                    handleValueChange('has_min_items', 0);
                                    handleValueChange('min_items', "");
                                    handleValueChange('has_quantity', 0);
                                    handleValueChange('quantity', "");
                                    handleValueChange('has_limit_per_customer', 0);
                                    handleValueChange('limit', "");
                                    handleValueChange('products', []);
                                    handleValueChange('categories', []);
                                    setSelectedProductCategoryList([]);
                                }}
                                data={discountApplyList}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.discount_type}</FormHelperText>}
                        </Grid>
                        {
                            values.discount_type === 'product' &&
                            <>
                                <Grid item xs={12} sm={12} pb={1}>
                                    <RadioButtonGroupInGrid
                                        title={'Applies to'}
                                        name={'product_applicability_type'}
                                        value={values.product_applicability_type}
                                        setValue={(e) => {
                                            handleValueChange('product_applicability_type', e);
                                            handleValueChange('apply_to_all_product', null);
                                            handleValueChange('apply_to_all_category', null);
                                            setSelectedProductCategoryList([]);
                                            if (e === "products") {
                                                handleValueChange("categories", []);
                                            } else if (e === "categories") {
                                                handleValueChange("products", []);
                                            }
                                        }}
                                        data={promocodeApplyList}
                                    />
                                    {error && <FormHelperText sx={{ color: "red" }}>{error.product_applicability_type}</FormHelperText>}
                                </Grid>
                                {values?.product_applicability_type === "products" ?
                                    <Grid item xs={12} sm={12} pb={1}>
                                        <RadioButtonGroupInGrid
                                            title={`Which product can customers use this promo code on?`}
                                            name={'apply_to_all_product'}
                                            value={values.apply_to_all_product || "-1"}
                                            setValue={(e) =>
                                                <>
                                                    {handleValueChange('apply_to_all_product', e)}
                                                    {handleValueChange('apply_to_all_category', "0")}
                                                    { handleValueChange('products', [])}
                                                </>
                                            }
                                            data={[
                                                { label: `All products`, value: "1" },
                                                { label: `Selected products`, value: "0" },
                                            ]}
                                        />
                                        {error && <FormHelperText sx={{ color: "red" }}>{error.apply_to_all_product}</FormHelperText>}
                                    </Grid>
                                    :
                                    <Grid item xs={12} sm={12} pb={1}>
                                        <RadioButtonGroupInGrid
                                            title={`Which categories can customers use this promo code on?`}
                                            name={'apply_to_all_category'}
                                            value={values.apply_to_all_category || "-1"}
                                            setValue={(e) =>
                                                <>
                                                    {handleValueChange('apply_to_all_category', e)}
                                                    {handleValueChange('apply_to_all_product', "0")}
                                                    { handleValueChange('categories', [])}
                                                </>

                                            }
                                            data={[
                                                { label: `All categories`, value: "1" },
                                                { label: `Selected categories`, value: "0" },
                                            ]}
                                        />
                                        {error && <FormHelperText sx={{ color: "red" }}>{error.apply_to_all_category}</FormHelperText>}
                                    </Grid>
                                }
                            </>
                        }
                        {
                            ((values.apply_to_all_product == '0' && values.product_applicability_type === "products")
                                || (values.apply_to_all_category == '0' && values.product_applicability_type === "categories"))
                            && values?.discount_type === "product" &&
                            <>
                                <Grid item xs={12} sm={12} className="d-flex align-items-end mt-1">
                                    <CustomAutocomplete
                                        title={`Choose which ${values.product_applicability_type === "products" ? 'product' : 'categories'} to include (${selectedProductCategoryList?.length || '0'} selected)`}
                                        values={selectedProductCategory || "-1"}
                                        placeholder={`Search for a ${values.product_applicability_type === "products" ? 'product' : 'category'}`}
                                        data={values.product_applicability_type === "products" ? filteredProList?.filter((x, idx) => x?.product_type !== "variant") : filteredCatList || []}
                                        valueName={"id"}
                                        labelName={"name"}
                                        onChange={(e, value) => setSelectedProductCategory(value?.id)}
                                    />
                                    <div >
                                        <CustomButton
                                            title={'Add'}
                                            press={() => handleAddSelectedProductCategory(values.product_applicability_type)}
                                            backgroundColor={'#101010'}
                                            textColor={'white'}
                                            marginLeft={10}
                                            height={40}
                                        />
                                    </div>
                                </Grid>
                                <div>
                                    {error && <FormHelperText sx={{ color: "red" }}>{(error?.products || error?.categories)}</FormHelperText>}
                                </div>
                                {
                                    selectedProductCategoryList?.length > 0 &&
                                    <div className="mt-3 w-100">
                                        <Table
                                            header={header}
                                            data={selectedProductCategoryList}
                                            pageSize={selectedProductCategoryList.length}
                                            totalPage={1}
                                        />
                                    </div>
                                }
                            </>
                        }

                    </Grid>
                    {/* {
                        selectedProductCategoryList?.length > 0 &&
                        <div className="mt-3">
                            <Table
                                header={header}
                                data={selectedProductCategoryList}
                                pageSize={selectedProductCategoryList.length}
                                totalPage={1}
                            />
                        </div>
                    } */}
                </CardBody>
            </Card>
        )
    }

    const handleMinimumOrderValueChange = (e) => {
        if (e === "has_min_spend") {
            setMinOrderValue("has_min_spend")
            handleValueChange("has_min_spend", 1)
        } else {
            handleValueChange("has_min_spend", 0)
            handleValueChange("min_spend", "")
            setItemAmount("")
        }

        if (e === "has_min_items") {
            setMinOrderValue("has_min_items")
            handleValueChange("has_min_items", 1)
        } else {
            handleValueChange("has_min_items", 0)
            handleValueChange("min_items", "")
            setTotalOrder("")

        }

        if (e === "no_min_spend") {
            setMinOrderValue("no_min_spend")
            handleValueChange("has_min_spend", 0)
            handleValueChange("min_items", "")
            handleValueChange("min_spend", "")
            setTotalOrder("")
            setItemAmount("")
        }

    }

    const renderRestrictionsForm = () => {
        return (
            <Card className="p-3 px-2 mt-3">
                <CardBody>
                    <div className="setting-header">RESTRICTIONS</div>
                    <Divider className="my-2 mb-4" />
                    <Grid container>
                        <Grid item xs={12}>
                            <RadioButtonGroupInGrid
                                title={'Minimum order value'}
                                name={'minOrderValue'}
                                value={minOrderValue}
                                setValue={(e) => handleMinimumOrderValueChange(e)}
                                data={minOrderList}
                                sm={4}
                                xs={6}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error?.has_min_spend}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={4}></Grid>
                        <Grid item xs={12} sm={4} padding={0} margin={0}>
                            {
                                values.has_min_items === 1 &&
                                <CustomTextField
                                    values={itemAmount}
                                    onChange={(e) => { setItemAmount(e); handleValueChange("min_items", e) }}
                                    placeholder={"0"}
                                    type={"phone"}
                                    error={error?.min_items}
                                />
                            }
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            {
                                values?.has_min_spend === 1 &&
                                <CustomTextField
                                    values={totalOrder}
                                    onChange={(e) => { setTotalOrder(e); handleValueChange("min_spend", e) }}
                                    placeholder={"0"}
                                    type={"number"}
                                    error={error?.min_spend}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                                    }}
                                />
                            }
                        </Grid>
                        <Grid item xs={12} sm={6} pb={1} mt={1}>
                            <RadioButtonGroupInGrid
                                title={'Has quantity? (promo code)'}
                                name={'has_quantity'}
                                value={isPromocodeHasQuantity}
                                setValue={setIsPromocodeHasQuantity}
                                data={yesNoList}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error?.has_quantity}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                            {
                                isPromocodeHasQuantity == '1' &&
                                <CustomTextField
                                    title={'Quantity of promo code'}
                                    values={parseInt(values?.quantity) || ""}
                                    onChange={(e) => handleValueChange('quantity', e)}
                                    type={'phone'}
                                    placeholder="0"
                                    error={error && error?.quantity}
                                />
                            }
                        </Grid>
                        <Grid item xs={12} sm={6} pb={1} mt={1}>
                            <RadioButtonGroupInGrid
                                title={'Has usage limit per customer?'}
                                name={'has_usage_limit'}
                                value={hasUsageLimit}
                                setValue={setHasUsageLimit}
                                data={yesNoList}
                            />
                            {error && <FormHelperText sx={{ color: "red" }}>{error.has_limit_per_customer}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                            {
                                hasUsageLimit == "1" &&
                                <CustomTextField
                                    title={'Usage limit per customer'}
                                    values={parseInt(values?.limit) || ""}
                                    onChange={(e) => handleValueChange('limit', e)}
                                    type={'phone'}
                                    placeholder="0"
                                    error={error && error?.limit}
                                />
                            }
                        </Grid>
                    </Grid>
                </CardBody>
            </Card>
        )
    }

    const renderSettingForm = () => {
        return (
            <Card className="p-3 px-2">
                <CardBody>
                    <div className="setting-header">SETTINGS</div>
                    <Divider className="my-2 mb-4" />
                    <div className="mt-3 mb-2">
                        <RadioButtonGroupInGrid
                            title={'Status'}
                            value={values.status}
                            data={statusList}
                            setValue={(e) => handleValueChange('status', e)}
                            required="true"
                            name="status"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                    </div>
                    <CustomTextField
                        title={'Sort Order'}
                        values={values?.sort_order}
                        onChange={(e) => handleValueChange('sort_order', e)}
                        placeholder={'0'}
                        type={'phone'}
                        error={error && error?.sort_order}
                    />
                </CardBody>
            </Card>
        )
    }
    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={type === 'Add' ? 'Save' : 'Save Changes'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <LoadingDialog open={loading || !promocodeDetails} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/promo-code"}
                        breadcrumbItems={[{ title: "Promo Code", link: "/promo-code" },
                        { title: title, link: "#" },
                        ]}
                    >
                        {
                            width > 425 &&
                            <CustomButton
                                title={type === 'Add' ? 'Save' : 'Save Changes'}
                                press={() => handleSubmit(type)}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumbs>
                    <Grid container spacing={2}>
                        <Grid item sm={12} lg={8} pb={3}>
                            {renderBasicInfoForm()}
                            {renderPromocodeDetailsForm()}
                            {renderValidityForm()}
                            {renderApplicabilityForm()}
                            {renderRestrictionsForm()}
                        </Grid>
                        <Grid container item sm={12} lg={4}>
                            <Grid item xs={12} sm={12}>
                                {renderSettingForm()}
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>

            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Promocode, General, Category, Login }) {
    return {
        promocodeDetails: Promocode.promocodeDetails,
        roleList: General.roleList,
        addPromocodeArr: Promocode.addPromocode,
        editPromocode: Promocode.updatePromocode,
        errorPromocode: Promocode.error,
        attachment: General.attachment,
        categoryListing: General.categories,
        userPermission: Login.permissionArry,
        productListing: General.products,

    };
}


export default connect(mapStateToProps)(AddPromoCode);
